// src/components/Results.js
import React, { useState, useEffect } from 'react';
import { db, doc, getDoc, setDoc, updateDoc, increment } from '../firebase';
import './Results.css';

const slides = [
  { id: 1, src: '/images/cbse_chemistry_toppers_2025_26.png', alt: 'CBSE Chemistry Toppers 2025-26' },
  { id: 2, src: '/images/cbse_chemistry_achievers_2025_26.png', alt: 'CBSE Chemistry Achievers 2025-26' }
];

const Results = () => {
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [likes, setLikes] = useState({1: 0, 2: 0});
  const [userLiked, setUserLiked] = useState({1: false, 2: false});
  const [loading, setLoading] = useState(true);

  // Load likes from Firebase
  const loadLikes = async () => {
    try {
      // Check if user has liked before (from localStorage)
      const likedStatus = localStorage.getItem('userLiked');
      if (likedStatus) {
        setUserLiked(JSON.parse(likedStatus));
      }

      // Load likes from Firebase
      const likesMap = {};
      for (let i = 1; i <= 2; i++) {
        const docRef = doc(db, 'likes', `image_${i}`);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          likesMap[i] = docSnap.data().count;
        } else {
          // Initialize if doesn't exist
          await setDoc(docRef, { count: 0 });
          likesMap[i] = 0;
        }
      }
      setLikes(likesMap);
    } catch (error) {
      console.error('Error loading likes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLike = async (imageId) => {
  try {
    const docRef = doc(db, 'likes', `image_${imageId}`);

    // If already liked → unlike
    if (userLiked[imageId]) {
      await updateDoc(docRef, {
        count: increment(-1)
      });

      setLikes(prev => ({
        ...prev,
        [imageId]: Math.max(prev[imageId] - 1, 0)
      }));

      const newUserLiked = {
        ...userLiked,
        [imageId]: false
      };

      setUserLiked(newUserLiked);
      localStorage.setItem('userLiked', JSON.stringify(newUserLiked));

    } else {
      // Like
      await updateDoc(docRef, {
        count: increment(1)
      });

      setLikes(prev => ({
        ...prev,
        [imageId]: prev[imageId] + 1
      }));

      const newUserLiked = {
        ...userLiked,
        [imageId]: true
      };

      setUserLiked(newUserLiked);
      localStorage.setItem('userLiked', JSON.stringify(newUserLiked));
    }

  } catch (error) {
    console.error('Error updating like:', error);
  }
};

  useEffect(() => {
    loadLikes();
  }, []);

  // Rest of your carousel functions
  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (i) => {
    if (isAnimating || i === index) return;
    setIsAnimating(true);
    setIndex(i);
  };

  const openLightbox = () => {
    setSelectedImage(slides[index]);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='1000' viewBox='0 0 800 1000'%3E%3Crect width='800' height='1000' fill='%23f3f4f6'/%3E%3Ctext x='400' y='500' font-size='20' fill='%239ca3af' text-anchor='middle'%3EImage%20Not%20Found%3C/text%3E%3C/svg%3E`;
  };

  const handleShare = async (image) => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: image.alt,
          text: 'Check out our CBSE Chemistry Results!',
          url: window.location.origin + image.src,
        });
      } else {
        await navigator.clipboard.writeText(window.location.origin + image.src);
        alert('Link copied to clipboard!');
      }
    } catch (err) {
      console.log('Share cancelled');
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), 500);
    return () => clearTimeout(timer);
  }, [index]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && lightboxOpen) {
        closeLightbox();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [lightboxOpen]);

  if (loading) {
    return (
      <section id="results" className="results-section-premium">
        <div className="results-container-premium">
          <div className="results-header-premium">
            <div className="results-badge">OUTSTANDING RESULTS</div>
            <h2 className="results-title-premium">
              Excellence in <span className="gradient-text">Chemistry</span>
            </h2>
            <p className="results-subtitle-premium">
              Celebrating outstanding performance and academic brilliance
            </p>
          </div>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>Loading results...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="results" className="results-section-premium">
      <div className="results-container-premium">
        <div className="results-header-premium">
          <div className="results-badge">OUTSTANDING RESULTS</div>
          <h2 className="results-title-premium">
            Excellence in <span className="gradient-text">Chemistry</span>
          </h2>
          <p className="results-subtitle-premium">
            Celebrating outstanding performance and academic brilliance
          </p>
        </div>

        <div className="results-carousel-premium">
          <div className="carousel-container-premium">
            <button className="carousel-nav premium-prev" onClick={prevSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="carousel-track-premium">
              {slides.map((slide, i) => (
                <div key={slide.id} className={`carousel-slide-premium ${i === index ? 'active' : ''}`}>
                  <div className="slide-inner-premium">
                    <div className="slide-image-premium">
                      <div className="image-frame-premium">
                        <div className="image-glow"></div>
                        <img 
                          src={slide.src} 
                          alt={slide.alt}
                          className="full-image"
                          onClick={openLightbox}
                          onError={handleImageError}
                        />
                        <button className="zoom-icon-btn" onClick={openLightbox}>
                          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            <line x1="11" y1="8" x2="11" y2="14"></line>
                            <line x1="8" y1="11" x2="14" y2="11"></line>
                          </svg>
                          <span className="zoom-tooltip">View full size</span>
                        </button>
                        <button className="share-icon-btn" onClick={() => handleShare(slide)}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="18" cy="5" r="3"></circle>
                            <circle cx="6" cy="12" r="3"></circle>
                            <circle cx="18" cy="19" r="3"></circle>
                            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                          </svg>
                          <span className="share-tooltip">Share</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="carousel-nav premium-next" onClick={nextSlide}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div className="carousel-progress-premium">
            <div className="progress-bars">
              {slides.map((_, i) => (
                <div key={i} className={`progress-bar ${i === index ? 'active' : ''}`} onClick={() => goToSlide(i)}>
                  <div className="progress-fill" style={{ width: i === index ? '100%' : '0%' }}></div>
                </div>
              ))}
            </div>
            <div className="progress-numbers">
              <span className="current">0{index + 1}</span>
              <span className="separator">/</span>
              <span className="total">0{slides.length}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxOpen && selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
            <div className="lightbox-header">
              <button 
                className="lightbox-like" 
                onClick={() => handleLike(selectedImage.id)}
              >
                <svg 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill={userLiked[selectedImage.id] ? "#ef4444" : "none"} 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
                {likes[selectedImage.id] > 0 && (
                  <span className="like-count">{likes[selectedImage.id]}</span>
                )}
              </button>
              
              <button className="lightbox-share" onClick={() => handleShare(selectedImage)}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
              </button>
              
              <button className="lightbox-close" onClick={closeLightbox}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <div className="lightbox-image-container">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt} 
                className="lightbox-image" 
                onError={handleImageError} 
              />
            </div>
            <div className="lightbox-caption">
              <p>{selectedImage.alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Results;